let uid = 0;

export default {
    props: {
        timeout: {
            type: Number,
            default: 3000,
            validator: value => value >= 0,
        },
        showCount: {
            type: Number,
            default: 1,
            validator: value => value >= 0,
        },
    },
    data() {
        return {
            running: false,
            notifications: [],
            queue: []
        };
    },
    methods: {
        add(list) {
            this.queue = this.queue.concat(list);

            if (!this.running) {
                this.show();
            }
        },
        remove(data) {
            clearTimeout(data.timer);
            let index = this.notifications.indexOf(data);
            this.notifications.splice(index, 1);
            this.show();
        },
        show() {
            if (this.queue.length > 0) {
                this.running = true;
                while ( this.queue.length > 0 && this.notifications.length < this.showCount) {
                    let data = this.queue.shift();
                    data.key = uid++;
                    data.timer = setTimeout(() => this.remove(data), this.timeout);

                    this.notifications.push(data);
                }
            }

            if (this.queue.length <= 0) {
                this.running = false;
            }
        }
    },    
};